export default __webpack_public_path__ + "static/media/glass.96b6b576.jpg";